import { createTheme } from "@fluentui/react";

import { webDarkTheme, webLightTheme } from "@fluentui/react-theme";
import { CustomAppTheme } from "../../CustomAppTheme";

export const defaultLightTheme = createTheme({
  palette: {
    // main colors
    themeDarker: "#0e336a", // shade30
    themeDark: "#13458f", // shade20
    themeDarkAlt: "#1651aa", // shade10
    themePrimary: "#185abd", // main color
    themeSecondary: "#2e6ac5", // tint10
    themeTertiary: "#6794d7", // tint20
    themeLight: "#aec6eb", // tint30
    themeLighter: "#d2e0f4", // tint40

    // neutral colors
    neutralDark: "#252423", // gray180
    neutralPrimary: "#323130", // gray160
    neutralPrimaryAlt: "#605E5C", // gray130
    neutralSecondary: "#797775", // gray120
    neutralSecondaryAlt: "#8A8886", // gray110
    neutralTertiary: "#B3B0AD", // gray80
    neutralTertiaryAlt: "#BEBBB8", // gray70
    neutralQuaternary: "#C8C6C4", // gray60
    neutralQuaternaryAlt: "#D2D0CE", // gray50
    neutralLight: "#E1DFDD", // gray40
    neutralLighter: "#EDEBE9", // gray30
    neutralLighterAlt: "#F3F2F1", // gray20
    black: "#000000",
    white: "#FFFFFF",
  },
});

export const defaultDarkTheme = createTheme({
  palette: {
    themeDarker: "#82ABF1",
    themeDark: "#598FEC",
    themeDarkAlt: "#3D7CE8",
    themePrimary: "#296FE6",
    themeSecondary: "#2461CA",
    themeTertiary: "#19428A",
    themeLight: "#0C2145",
    themeLighter: "#071225",

    // neutral colors
    neutralDark: "#F3F2F1", // gray20
    neutralPrimary: "#D2D0CE", // gray50
    neutralPrimaryAlt: "#B3B0AD", // gray80
    neutralSecondary: "#979593", // gray100
    neutralSecondaryAlt: "#797775", // gray120
    neutralTertiary: "#605E5C", // gray130
    neutralTertiaryAlt: "#484644", // gray140
    neutralQuaternary: "#3B3A39", // gray150
    neutralQuaternaryAlt: "#292827", // gray170
    neutralLight: "#323130", // gray160
    neutralLighter: "#1B1A19", // gray200
    neutralLighterAlt: "#252423", // gray180
    black: "#FFFFFF",
    white: "#000000",
  },
});

export const legacyNeutralColors = {
  // neutral colors
  legacy_neutralDark: "#252423", // gray180
  legacy_neutralPrimary: "#323130", // gray160
  legacy_neutralPrimaryAlt: "#605E5C", // gray130
  legacy_neutralSecondary: "#797775", // gray120
  legacy_neutralSecondaryAlt: "#8A8886", // gray110
  legacy_neutralTertiary: "#B3B0AD", // gray80
  legacy_neutralTertiaryAlt: "#BEBBB8", // gray70
  legacy_neutralQuaternary: "#C8C6C4", // gray60
  legacy_neutralQuaternaryAlt: "#D2D0CE", // gray50
  legacy_neutralLight: "#E1DFDD", // gray40
  legacy_neutralLighter: "#EDEBE9", // gray30
  legacy_neutralLighterAlt: "#F3F2F1", // gray20
  legacy_black: "#000000",
  legacy_white: "#FFFFFF",
};

export const defaultLightThemeNext: CustomAppTheme = {
  ...webLightTheme,
  // primary colors
  legacy_themeDarker: "#0e336a", // shade30
  legacy_themeDark: "#13458f", // shade20
  legacy_themeDarkAlt: "#1651aa", // shade10
  legacy_themePrimary: "#185abd", // main color
  legacy_themeSecondary: "#2e6ac5", // tint10
  legacy_themeTertiary: "#6794d7", // tint20
  legacy_themeLight: "#aec6eb", // tint30
  legacy_themeLighter: "#d2e0f4", // tint40

  ...legacyNeutralColors,
};

export const legacyDarkNeutralColors = {
  legacy_neutralDark: "#F3F2F1", // gray20
  legacy_neutralPrimary: "#D2D0CE", // gray50
  legacy_neutralPrimaryAlt: "#B3B0AD", // gray80
  legacy_neutralSecondary: "#979593", // gray100
  legacy_neutralSecondaryAlt: "#8A8886", // gray110
  legacy_neutralTertiary: "#797775", // gray120
  legacy_neutralTertiaryAlt: "#605E5C", // gray130
  legacy_neutralQuaternary: "#484644", // gray140
  legacy_neutralQuaternaryAlt: "#3B3A39", // gray150
  legacy_neutralLight: "#323130", // gray160
  legacy_neutralLighter: "#292827", // gray170
  legacy_neutralLighterAlt: "#252423", // gray180
  legacy_black: "#FFFFFF",
  legacy_white: "#1B1A19",
};

export const defaultDarkThemeNext: CustomAppTheme = {
  ...webDarkTheme,
  // main colors
  legacy_themeDarker: "#82ABF1",
  legacy_themeDark: "#598FEC",
  legacy_themeDarkAlt: "#3D7CE8",
  legacy_themePrimary: "#296FE6",
  legacy_themeSecondary: "#2461CA",
  legacy_themeTertiary: "#19428A",
  legacy_themeLight: "#0C2145",
  legacy_themeLighter: "#071225",

  ...legacyDarkNeutralColors,
};
